// RUTATEC — Page Header (prototype-aligned)
interface PageHeaderProps {
  title: string
  subtitle?: string
  action?: React.ReactNode
}

export const PageHeader: React.FC<PageHeaderProps> = ({ title, subtitle, action }) => (
  <div className="flex items-start justify-between mb-5">
    <div>
      <h1 className="font-display text-[22px] font-bold text-navy tracking-wide leading-tight">
        {title}
      </h1>
      {subtitle && (
        <p className="text-[12px] text-gray mt-1">{subtitle}</p>
      )}
    </div>
    {action && (
      <div className="flex items-center gap-2 shrink-0 ml-4">
        {action}
      </div>
    )}
  </div>
)
